<template>
  <div class="container justify-content-center" >
    <Carusel />

    <div class="container shadow bg-body rounder p-4 mt-3" style="max-width: 300px">
      <h3 class="text-center mb-3">Вход в личный кабинет</h3>
      <form @submit="onSubmit">
        <div class="mb-3 row">
          <label for="username" class="col-sm-3 col-form-label">Email</label>
          <div class="col-sm-9">
            <input
              id="username"
              class="form-control"
              v-model="form.username"
              type="text"
              required
              placeholder=""
              @input="status.success = true"
            />
          </div>
        </div>
        <div class="mb-3 row">
          <label for="password" class="col-sm-3 col-form-label">Пароль</label>
          <div class="col-sm-9">
            <input
              id="password"
              class="form-control"
              v-model="form.password"
              type="password"
              required
              placeholder=""
              @input="status.success = true"
            />
          </div>
        </div>
        <div class="mb-0 row">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary mx-1">Вход</button>
            <router-link
              class="nav-link active btn btn-info mx-1"
              aria-current="page"
              :to="{ name: 'loginByCode' }"
              >Вход по коду</router-link
            >
            <router-link
              v-if="false"
              class="nav-link active btn btn-light"
              aria-current="page"
              :to="{ name: 'singup' }"
              >Регистрация</router-link
            >
          </div>
          <div class=" mt-3 text-center">
            <span class=" text-danger" v-if="!status.success">
              <span class="text-center" v-if="status.err">
                {{ status.err }}
              </span>
              <span class="mt-3" v-if="status.err == ''"> Не верные имя или пароль </span>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Carusel from "./Carusel.vue";

export default {
  name: "Login",
  components: { Carusel },

  setup(props) {
    const store = useStore();
    const router = useRouter();

    const form = ref({
      username: "",
      password: ""
    });
    const status = ref({
      success: true,
      err: ""
    });

    const onSubmit = async evt => {
      evt.preventDefault();
      status.value = await store.dispatch("obtainToken", form.value);
      if (status.value.success) {
        router.push({ name: "home" });
        //document.location.reload(true);
      }
    };

    return {
      status,
      store,
      form,
      onSubmit
    };
  }
};
</script>

<style scoped></style>
